import NewsCarousel from "../components/news_new_components/NewsCarousel";
import VerticalCardListing from "../components/news_new_components/VerticalCardListing";
import HorizontalCardListing from "../components/news_new_components/HorizontalCardListing";
import OverlayCardListing from "../components/news_new_components/OverlayCardListing";
import MainLayout from "../components/MainLayout";
import NewsSidebar from "../components/news_components/news-sidebar";
import { useEffect, useState } from "react";
import { getNews } from "../services/news";
import { successToast,errorToast } from '../utils/toasters'
import { Loader2 } from "lucide-react";

function NewsnewPage() {
  // Find each section by ID
  const [newsData, setNewsData] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const [featuredSection, setFeaturedSection] = useState([]);
  const [usNewsSection, setUsNewsSection] = useState([]);
  const [backHomeSection, setBackHomeSection] = useState([]);
  const [sportsSection, setSportsSection] = useState([]);
  const [entertainmentSection, setEntertainmentSection] = useState([]);
  const [localBuzz, setLocalBuzz] = useState([]);

  useEffect(() => {
    async function newsFetcher() {
      try {
        setIsProcessing(true);
        const newsResponse = await getNews();

        newsResponse.forEach((newsCategory) => {
          if (newsCategory.category === "US") {
            setFeaturedSection(newsCategory.news.slice(0, 1));
            setLocalBuzz(newsCategory.news.slice(1, 4));
            setUsNewsSection(newsCategory.news.slice(4));
          } else if (newsCategory.category === "Back Home") {
            setFeaturedSection((prev) => [...prev, newsCategory.news[0]]);
            setLocalBuzz((prev) => [...prev, ...newsCategory.news.slice(1, 4)]);
            setBackHomeSection(newsCategory.news.slice(4));
          } else if (newsCategory.category === "Entertainment") {
            setFeaturedSection((prev) => [...prev, newsCategory.news[0]]);
            setEntertainmentSection(newsCategory.news.slice(1));
          } else if (newsCategory.category === "Sports") {
            setFeaturedSection((prev) => [...prev, newsCategory.news[0]]);
            setLocalBuzz((prev) => [...prev, ...newsCategory.news.slice(1, 4)]);
            setSportsSection(newsCategory.news.slice(4));
          }
        });
      } catch (error) {
        console.error("Error while fetching News", error);
        errorToast("Error while fetching News");
      } finally {
        setIsProcessing(false);
      }
    }
    newsFetcher();
  }, []);

  return (
    <MainLayout
      rightSidebar={localBuzz && <NewsSidebar localBuzz={localBuzz} />}
      rs={true}
    >
      {isProcessing && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center z-50">
          <Loader2 className="animate-spin" width={64} height={64} />
        </div>
      )}

      <div className="w-full max-w-3xl no-scrollbar p-3">
        {/* Featured Carousel */}
        {featuredSection && <NewsCarousel featuredSection={featuredSection} />}

        {/* US News Section */}
        {usNewsSection && usNewsSection.length > 0 && (
          <div className="mt-12 w-full">
            <h2 className="text-xl md:text-2xl font-bold mb-6 font-fraunces">
              US News
            </h2>
            <VerticalCardListing items={usNewsSection} />
          </div>
        )}

        {/* Back Home Section */}
        {backHomeSection && backHomeSection.length > 0 && (
          <div className="mt-12 w-full">
            <h2 className="text-xl md:text-2xl font-bold mb-6 font-fraunces">
              Back Home
            </h2>
            <HorizontalCardListing items={backHomeSection} />
          </div>
        )}

        {/* Sports Section */}
        {sportsSection && sportsSection.length > 0 && (
          <div className="mt-12 w-full">
            <h2 className="text-xl md:text-2xl font-bold mb-6 font-fraunces">
              Sports
            </h2>
            <OverlayCardListing items={sportsSection} />
          </div>
        )}

        {/* Entertainment Section */}
        {entertainmentSection && entertainmentSection.length > 0 && (
          <div className="mt-12 w-full">
            <h2 className="text-xl md:text-2xl font-bold mb-6 font-fraunces">
              Entertainment
            </h2>
            <OverlayCardListing items={entertainmentSection} />
          </div>
        )}
      </div>
    </MainLayout>
  );
}

export default NewsnewPage;
